import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import {
	BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import utils from "../../../utils/validateScanner";

export default {
	name: 'dashboard',
	mixins: [utils],
	components: {
		BasicSelect,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			isLoading: false,
			sourcehublist: [],
			isSourceError: '',
			sourcehubitem: {
				id: '',
				text: ''
			},
			warehouselist: [],
			warehousereportdata: [],
			topsupplier: [],
			lowsupplier: [],
			pageno: 0,
			pagecount: 0,
			warehouseid: '',
			clientid: '',
			userid: '',
			todayinwardcount: 0,
			myStr: '',
			dashbaorddata: [],
			totalbags: 0,
			bagopen: 0,
			bagclosed: 0,
			scheduled: 0,
			outscan: 0,
			hubLoading: ''
			//pie chart end
		}
	},
	created: function() {
		// when a page loads,mounted() will be call
	},

	filters: {
		moment: function(date) {
			if (date == '' || date == null) {
				return '--'
			}
			return moment(date).format('DD-MM-YYYY HH:mm');
		},
		toFixed: function(value) {
			if (value > 0) {
				return value.toFixed(3)
			} else {
				return 0;
			}
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		// console.log(userdetail);
		this.uasertype = userdetail[0].utype;
		this.username = userdetail[0].FirstName;
		this.hubid = userdetail[0].HubId;
		this.useremail = userdetail[0].email
		this.dashboardcount();
		this.getHubList();
		this.getHubDetails(this.hubid[0],'dashboard');
		this.hubForManualRestriction();
	},
	methods: {
		getHubList() {
			this.destinationhublist = [];
			this.hubLoading = 'Loading Hub...'
			this.input = {
				hubids: this.hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					this.HubDetails = result.data.ResponseData
					for (var i = 0; i < this.HubDetails.length; i++) {
						this.destinationhublist.push({
							"id": this.HubDetails[i].HubID,
							"text": this.HubDetails[i].HubName + '(' + this.HubDetails[i].HubID + ')',
						})
						this.allHubMaster = this.destinationhublist;
						this.sourcehublist = this.destinationhublist;
						this.allHub = this.destinationhublist;
					}
				}, error => {
					console.error(error)
				})
		},

   
		SelectSourceHub(sourcehubitem) {
			this.sourcehubitem = sourcehubitem
			var a = this.sourcehubitem.id
			this.destinationhublist = this.allHubMaster.filter(function(el) {
				return el.id != a
			});
			if (this.sourcehubitem.text != '') {
				this.isSourceError = '',
					this.Sourceerrors = ''
			} else {
				this.isSourceError = '1',
					this.Sourceerrors = 'The Source Hub Name field is required.'
			}
			this.dashboardcount(a)
		},
		async dashboardcount(a) {
			var url = ''

			if (a == undefined || a == '' || a == null) {
				if (this.hubid.length > 1) {
					url = apiUrl.api_url_hubops + 'getBagCounts';
				} else {
					url = apiUrl.api_url_hubops + 'getBagCounts?currenthubid=' + this.hubid;
				}
			} else {
				// console.log(a);
				url = apiUrl.api_url_hubops + 'getBagCounts?currenthubid=' + a
			}
			this.isLoading = true
			await axios({
				'method': 'GET',
				'url': url,
				'headers': {
					'Authorization': "authkey xB84JJ89Hd25"
				}
			}).then(result => {
				this.dashbaorddata = result.data.ResponseData[0];
				this.totalbags = this.dashbaorddata.totalbags != 0 || null ? this.dashbaorddata.totalbags : 0;
				this.bagopen = this.dashbaorddata.bagopen !== null ? this.dashbaorddata.bagopen : 0;
				this.bagclosed = this.dashbaorddata.bagclosed !== null ? this.dashbaorddata.bagclosed : 0;
				this.scheduled = this.dashbaorddata.scheduled !== null ? this.dashbaorddata.scheduled : 0;
				this.outscan = this.dashbaorddata.outscan !== null ? this.dashbaorddata.outscan : 0;
				this.isLoading = false
			}, error => {
				this.isLoading = false
				console.log(error);
			})
		},
		resetForm() {
			this.sourcehubitem = {
				id: '',
				text: ''
			};
			this.dashboardcount();
		},

		redirectLink(){
			if(process.env.NODE_ENV=='production'){
				window.open("https://eagle.xbees.in/breach/facility-dashboard", "_blank");
			}else{
				window.open("https://stage-eagle.xbees.in/breach/facility-dashboard", "_blank");
			}
		},

		redirectTMSLink(){
			const baseUrl = apiUrl.TMSRedirectionalUrl + "VehicleApprovalRequest";

            const params = new URLSearchParams({
				LoginHubIDName:this.hubname,
				TrackType: "MM",            
			});

			window.open(`${baseUrl}?${params.toString()}, "_blank"`);
		},

		redirectCRMLink(){
			const baseUrl = apiUrl.CRMRedirectionalUrl + 'b2b/dashboard';
			window.open(baseUrl, '_blank');
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/dashboard/dashboard.component.js